/**
 * Contact Form Auto-fill from URL Parameter
 * Fills the message textarea with content from ?message= URL parameter
 */

(function() {
  'use strict';

  function prefillContactForm() {
    // Check if we're on the contact page
    const messageTextarea = document.querySelector('#ContactForm-body, textarea[name="contact[Message]"]');
    
    if (!messageTextarea) {
      return; // Not on contact page or form not found
    }
    
    // Get the message parameter from URL
    const urlParams = new URLSearchParams(window.location.search);
    const message = urlParams.get('message');
    
    if (message) {
      // Decode and set the message
      messageTextarea.value = decodeURIComponent(message);
      
      // Optional: Focus the textarea so user knows it's been filled
      messageTextarea.focus();
      
      // Optional: Scroll to the form
      messageTextarea.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prefillContactForm);
  } else {
    prefillContactForm();
  }
})();